function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);




document.addEventListener("DOMContentLoaded", function () {

  const FREE_VARIANT_ID = 56439354949967; // deine Gratis-Variant ID
  const MINIMUM_CART_VALUE = 50.00; // Mindestbestellwert für Geschenk

  // nach jedem ATC Button klicken prüfen
  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-add-to-cart], .product-form__submit, #AddToCart, button.add-to-cart");

    if (!btn) return;
    setTimeout(checkAndAddGift, 400); // Booster Theme lädt AJAX → kleine Verzögerung
  });

  function checkAndAddGift() {

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        let subtotal = cart.items_subtotal_price / 100; // Shopify gibt Cent zurück
        let giftExists = cart.items.some(item => item.variant_id == FREE_VARIANT_ID);

        // Geschenk entfernen wenn < 50 €
        if (subtotal < MINIMUM_CART_VALUE) {
          if (giftExists) {
            removeGift();
          }
          return;
        }

        // Geschenk hinzufügen wenn ≥ 50 €
        if (!giftExists) {
          addGift();
        }
      });
  }

  function addGift() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: FREE_VARIANT_ID,
        quantity: 1
      })
    })
    .then(() => {
      if (window.BoosterTheme && BoosterTheme.CART) {
        BoosterTheme.CART.updateCart();
      }
    });
  }

  function removeGift() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        let giftLine = cart.items.find(item => item.variant_id == FREE_VARIANT_ID);
        if (!giftLine) return;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: giftLine.key,
            quantity: 0
          })
        })
        .then(() => {
          if (window.BoosterTheme && BoosterTheme.CART) {
            BoosterTheme.CART.updateCart();
          }
        });
      });
  }
});

/* ============================
   AUTOMATISCHES GRATIS-PRODUKT
   ============================ */
(function () {
  // 👉 Deine Gratis-Variant-ID
  const FREE_VARIANT_ID = 56545481982287;

  // 👉 Mindestwarenwert in EUR (z.B. 50 €)
  const MINIMUM_CART_VALUE = 50;

  // Gratisartikel hinzufügen
  function addGift() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: FREE_VARIANT_ID,
        quantity: 1,
        properties: { _free_gift: true } // Markierung als Geschenk
      })
    })
      .then(() => {
        // Mini-Cart / Drawer neu laden (Booster/BoosterTheme/Pumper usw.)
        if (window.BoosterTheme && BoosterTheme.CART && BoosterTheme.CART.fetchCart) {
          BoosterTheme.CART.fetchCart();
        } else {
          // Fallback: Seite neu laden, falls kein Ajax-Cart vorhanden
          location.reload();
        }
      })
      .catch(err => console.error('Fehler beim Geschenk hinzufügen:', err));
  }

  // Gratisartikel entfernen
  function removeGift() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const giftItem = cart.items.find(item => item.variant_id == FREE_VARIANT_ID);
        if (!giftItem) return;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        })
          .then(() => {
            if (window.BoosterTheme && BoosterTheme.CART && BoosterTheme.CART.fetchCart) {
              BoosterTheme.CART.fetchCart();
            } else {
              location.reload();
            }
          })
          .catch(err => console.error('Fehler beim Geschenk entfernen:', err));
      });
  }

  // Prüfen, ob Geschenk hinzugefügt / entfernt werden muss
  function checkGift() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Shopify gibt Preise in Cent zurück → durch 100 teilen
        const subtotal = cart.items_subtotal_price / 100;
        const giftExists = cart.items.some(item => item.variant_id == FREE_VARIANT_ID);

        // Unter Mindestwert → Geschenk entfernen
        if (subtotal < MINIMUM_CART_VALUE && giftExists) {
          removeGift();
          return;
        }

        // Über Mindestwert → Geschenk hinzufügen
        if (subtotal >= MINIMUM_CART_VALUE && !giftExists) {
          addGift();
        }
      })
      .catch(err => console.error('Fehler beim Gift-Check:', err));
  }

  // Beim Laden der Seite prüfen + alle 5 Sekunden erneut
  document.addEventListener('DOMContentLoaded', function () {
    checkGift();
    // Aus Performance-Gründen nicht zu häufig – 5 Sek. ist ok
    setInterval(checkGift, 5000);
  });
})();
